import React from "react";

// `src` is widened to `string | number` to mirror the cross-platform
// Image type. On web (Vite) PNG imports always resolve to string URLs at
// runtime, so the number branch is type-only and never reached.
type ImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  contentFit?: never;
  maxHeight?: number;
  maxWidth?: number;
  src?: string | number;
};

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  ({ contentFit: _contentFit, maxHeight, maxWidth, src, ...props }, ref) => {
    return (
      <img ref={ref} style={{ maxHeight, maxWidth }} src={src as string | undefined} {...props} />
    );
  },
);
